// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3104":"81e24966","3350":"047a3c54","4055":"55c5d16a","8056":"f088af95","8570":"81e24966","9630":"047a3c54"}[chunkId] + ".chunk.css";
};